import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import getTestProps from 'test/lib/cypress/getTestProps';
import Breadcrumb, {BreadcrumbItem} from 'ui-library/Breadcrumb';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface AnalysisHeaderBreadcrumbProps {
  analysis: AnalysisGraphQL;
}

/**
 * Breadcrumb navigation showing the project and folder containing the current analysis.
 * Displays a folder icon followed by clickable project and folder links.
 */
export default function AnalysisHeaderBreadcrumb({analysis}: AnalysisHeaderBreadcrumbProps): JSX.Element {
  const items: Array<BreadcrumbItem> = [
    {
      label: analysis.project.name,
      href: analysis.project.url,
    },
  ];

  // Folders with the same urls as the project are just the root folder of the project
  if (analysis.folder.url !== analysis.project.url) {
    items.push({
      label: analysis.folder.name,
      href: analysis.folder.url,
    });
  }

  return (
    <div
      className={css(styles.wrapper)}
      {...getTestProps({component: 'AnalysisHeaderBreadcrumb', element: 'root'})}
    >
      <BenchlingIcon icon="folder-open" className={css(styles.icon)} />
      <Breadcrumb items={items} isLastItemInteractable={true} />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: 6,
  },
});
